import type { AppData } from "@/application/types";

export default {
  title: "4YourPlan",
  landingPage: { name: "tenantRegistration.show" },
  vuetifyOptions: {},
} satisfies AppData;
